import {Link} from "react-router-dom";
import {routes} from "../routes/routes";

const PageNotFoundView = () => {
    return (
        <div className="view">
            <h1 className="heading">Page not found</h1>
            <Link to={routes.dashboard}>Back to dashboard</Link>
        </div>
    )
};

export default PageNotFoundView;
